// Module
var code = "<div class=\"property-container\"></div> ";
// Exports
export default code;